import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import {
  HeaderContainer,
  OrderIssuesContainer,
  OrderIssuesDetails,
  OrderIssuesHeading,
  OrderIssuesText,
  StyledButton,
} from './styled';

export const NeedHelp = ({ children }: { children: React.ReactNode }) => {
  const { formatMessage } = useIntl();

  return (
    <OrderIssuesContainer>
      <HeaderContainer>
        <OrderIssuesHeading>{formatMessage({ id: 'needHelp' })}</OrderIssuesHeading>
      </HeaderContainer>
      <OrderIssuesDetails>
        <OrderIssuesText>
          {formatMessage({ id: 'visitSupportForHelpWithYourOrder' })}
        </OrderIssuesText>
        <Box>
          <StyledButton to={routes.support}>{formatMessage({ id: 'visitSupport' })}</StyledButton>
        </Box>
      </OrderIssuesDetails>

      {children}
    </OrderIssuesContainer>
  );
};
